import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import serviettesBlanches from "@/assets/products/serviettes-blanches.png";

const config: ProductPageConfig = {
  name: "Serviettes blanches",
  breadcrumbName: "Serviettes",
  subtitle: "Serviettes en papier blanches, douces et absorbantes pour la restauration",
  features: ["Recyclable", "2 plis", "Douce et absorbante", "Personnalisable", "Disponible en stock"],
  variants: [
    { name: "Serviette 25x32cm", dimensions: "25 x 32 cm", material: "Papier 2 plis", packaging: "Carton de 5 000 (50 x 100)", palette: "36 cartons", image: serviettesBlanches },
  ],
  customization: { maxColors: 4, minOrder: "100 000 pièces", bestPrice: "100 000 pièces" },
};

const Serviettes = () => <ProductPageLayout config={config} />;
export default Serviettes;
